<button [disabled]="disabled" (click)="onSortChange()">
  <img [src]="value === 'asc' ? sortAscendingIcon : sortDescendingIcon" />
</button>
